
const parseToGermanFloat = (value: any) => {
    let returnVal = "0";
    if (value){
        value = value.toString().replace(',', '.');
        returnVal = parseFloat(value).toString().replace('.', ',');
    }
    
    return returnVal;
}

const parseFloatFromGermanFloat = (value: string) => {
    let prepareVal = value.toString().replace(',', '.');
    let returnVal: number = 0;
    if(prepareVal)
        returnVal = parseFloat(prepareVal);
       
    if(isNaN(returnVal))
        returnVal = 0;
    
    return returnVal === 0 ? returnVal : returnVal.toFixed(2);
}

export {parseToGermanFloat, parseFloatFromGermanFloat};